import { render, staticRenderFns } from "./mailListDetail.vue?vue&type=template&id=6cce665b&scoped=true&"
import script from "./mailListDetail.vue?vue&type=script&lang=js&"
export * from "./mailListDetail.vue?vue&type=script&lang=js&"
import style0 from "./mailListDetail.vue?vue&type=style&index=0&id=6cce665b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce665b",
  null
  
)

export default component.exports